import { TextField } from '@mui/material'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '@/hooks/useAuth'
import { changeMapStyle } from '@/slices/map'

const stylesOptions = [
    {
        key: 0,
        text: 'OSM',
        value: 'osmStyle'
    },
    // {
    //     key  : 1,
    //     text : 'Original',
    //     value: 'originalStyle'
    // },
    {
        key: 1,
        text: 'Basic',
        value: 'basicStyle'
    },
    {
        key: 2,
        text: '3D',
        value: 'threeDStyle'
    },
    {
        key: 3,
        text: 'Bright',
        value: 'brightStyle'
    },
    {
        key: 4,
        text: 'Dark',
        value: 'darkmatterStyle'
    },
    {
        key: 5,
        text: 'Fiord',
        value: 'fiordStyle'
    },
    {
        key: 6,
        text: 'Liberty',
        value: 'libertyStyle'
    },
    {
        key: 7,
        text: 'Positron',
        value: 'positronStyle'
    },
    // {
    //     key  : 8,
    //     text : 'Terrain',
    //     value: 'terrainStyle'
    // },
    {
        key: 8,
        text: 'Toner',
        value: 'tonerStyle'
    }
]

const MapStyleSwitcher = ({ closeModal }) => {
    const dispatch = useDispatch()
    const { updateSettings, isAuthenticated } = useAuth()
    const mapStyle = useSelector((state) => state.map.selectedMapStyle)
    const dropdownChangeHandler = (newStyleName) => {
        dispatch(changeMapStyle({ styleName: newStyleName }))

        if (isAuthenticated) {
            updateSettings({
                model: 'user',
                attribute: ['style', 'mapStyle'],
                value: newStyleName
            })
        }

        if (closeModal) {
            closeModal()
        }
    }

    return (
        <TextField
            fullWidth
            name="location"
            onChange={(event) => {
                dropdownChangeHandler(event.target.value)
            }}
            value={mapStyle}
            variant="outlined"
            select
            slotProps={{
                select: { native: true }
            }}
        >
            {stylesOptions?.map((l) => (
                <option key={l.key} value={l.value}>
                    {l.text}
                </option>
            ))}
        </TextField>
    )
}

export default MapStyleSwitcher
